<cerrix-dialog [name]="name" data-uiid="risk-dialog-add-new-risk">
    <span header-title> Add new risk </span>
    <div class="new-risk-content" dialog-content>
        <span class="new-risk-description">Select how you want to add your new risk(s)</span>
        <div dialog-content class="new-risk-options">
            <div
                class="new-risk-option-manual"
                [class.active]="creaiDialogOption === 'manual'"
                (click)="creaiDialogOption = 'manual'"
                data-uiid="risk-dialog-add-new-risk--manual"
            >
                <div>
                    <div class="new-risk-option-title">Add manually</div>
                    <div class="new-risk-option-description">Create a new risk</div>
                </div>
                <mat-icon class="new-risk-icon" [svgIcon]="'add-list'"></mat-icon>
            </div>
            <div
                class="new-risk-option-ai"
                [class.active]="creaiDialogOption === 'ai'"
                (click)="creaiDialogOption = 'ai'"
                data-uiid="risk-dialog-add-new-risk--generate-ai"
            >
                <div>
                    <div class="new-risk-option-title">Extract with AI</div>
                    <div class="new-risk-option-description">
                        Extract risks and controls from a document with AI
                    </div>
                </div>
                <mat-icon class="new-risk-icon" [svgIcon]="'generate-ai'"></mat-icon>
            </div>
        </div>
    </div>
    <div class="new-risk-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            (click)="closeAddNewRiskDialog()"
            data-uiid="risk-dialog-add-new-risk--cancel"
            >Cancel</cerrix-button
        >
        <cerrix-button
            buttonSize="big"
            (click)="newRiskChoice()"
            data-uiid="risk-dialog-add-new-risk--continue"
            >Continue</cerrix-button
        >
    </div>
</cerrix-dialog>